export const calculateTimePassed = (postTime) => {
  if (!postTime) {
    return '';
  }

  const currentTime = new Date();
  const timeDifference = currentTime - new Date(postTime);

  const secondsDifference = Math.floor(timeDifference / 1000);

  const minute = 60;
  const hour = minute * 60;
  const day = hour * 24;
  const week = day * 7;

  if (secondsDifference < minute) {
    return 'Just now';
  }

  if (secondsDifference < hour) {
    const minutes = Math.floor(secondsDifference / minute);
    return `${minutes}min${minutes > 1 ? 's' : ''}`;
  }

  if (secondsDifference < day) {
    const hours = Math.floor(secondsDifference / hour);
    return `${hours}h`;
  }

  if (secondsDifference < week) {
    const days = Math.floor(secondsDifference / day);
    return `${days}d`;
  }

  const date = new Date(postTime);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });
};
